const micCategories = [
  {
    icon: "ri-car-line",
    title: "Кузовные детали",
    cluster: "Кластер Тайчжоу/Даньян",
    desc: "Капоты, крылья, двери. Погрешность штамповки ≤0.5 мм. Идеально для ремонта премиальных авто после ДТП.",
    specs: ["Погрешность ≤0.5 мм", "Покраска 1:1", "Антикоррозийное покрытие"],
  },
  {
    icon: "ri-dashboard-line",
    title: "Пластиковый экстерьер",
    cluster: "Заводы Тайчжоу/Чанчжоу",
    desc: "100% чистый PP-пластик, устойчивый к морозам. Не раскалывается при ударах в русскую зиму.",
    specs: ["100% чистый PP", "Морозостойкость", "Ударопрочность"],
  },
  {
    icon: "ri-flashlight-line",
    title: "Оптика и Освещение",
    cluster: "Производство в Даньяне",
    desc: "Матричные LED-фары 1:1 на базе импортных чипов, решающие проблему пожелтения старой оптики.",
    specs: ["Импортные LED-чипы", "Матричный свет 1:1", "Без пожелтения"],
  },
  {
    icon: "ri-settings-2-line",
    title: "Детали подвески",
    cluster: "Кластер Юйхуань",
    desc: "Кованый алюминий и морозостойкая резина из натурального каучука, исключающая разрывы в суровом климате.",
    specs: ["Кованый алюминий", "Натуральный каучук", "Морозостойкость"],
  },
  {
    icon: "ri-temp-hot-line",
    title: "Система охлаждения",
    cluster: "Специализированные заводы",
    desc: "Утолщённые алюминиевые радиаторы со специальным антикоррозийным покрытием против дорожной соли и реагентов.",
    specs: ["Утолщённый алюминий", "Антикоррозийное покрытие", "Защита от реагентов"],
  },
];

export default function MicSection() {
  return (
    <section id="mic" className="bg-[#0A0F1A] py-24 relative overflow-hidden">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/9e58f9f3fd5d0f8eb9ecb1d232448938.jpg"
          alt="Производство"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Made in China — Премиум аналоги</span>
          </div>
          <h2 className="text-white mb-6" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(32px, 4.5vw, 60px)", letterSpacing: "0.03em" }}>
            ФИЛОСОФИЯ «MADE IN CHINA»:<br />
            <span className="text-[#C9A84C]">ИДЕАЛЬНЫЙ БАЛАНС</span>
          </h2>
          <div className="max-w-3xl">
            <p className="text-gray-400 text-base leading-relaxed mb-4">
              Как гласит китайская пословица: «Нет самой низкой цены, всегда есть ещё дешевле». Но мы знаем: экстремально низкая цена убивает надёжность, а завышенная цена оригинала убивает вашу маржу.
            </p>
            <p className="text-white text-base leading-relaxed font-medium mb-4">
              Наша линейка «Made in China» разрушает стереотипы. Мы интегрировали лучшие промышленные кластеры Китая (Тайчжоу, Даньян), чтобы предложить вам детали, которые работают долго, позволяя вам зарабатывать в <strong className="text-[#C9A84C]">2–3 раза больше</strong>.
            </p>
            <p className="text-[#C9A84C] text-sm font-semibold border-l-2 border-[#C9A84C] pl-4">
              Мы — ведущий оператор автозапчастей с крупнейшей инфраструктурой поставок из КНР: физические склады, прямые контракты с заводами, собственная логистика и сертификация EAC.
            </p>
          </div>

          {/* ── СТРОГОЕ ПРЕДУПРЕЖДЕНИЕ — Highlight Card ── */}
          <div className="relative bg-gradient-to-r from-[#8B1A1A]/20 via-[#0D1420] to-[#0D1420] border border-red-900/60 rounded-sm p-7 mt-8 overflow-hidden">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-red-600"></div>
            <div className="pl-4">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-red-900/30 border border-red-700/50 rounded-sm flex-shrink-0">
                  <i className="ri-alarm-warning-line text-red-400 text-lg"></i>
                </div>
                <span className="text-red-400 text-[11px] font-black tracking-[0.35em] uppercase">Строгое предупреждение · Расходные материалы для ТО</span>
              </div>
              <blockquote className="text-white text-sm leading-relaxed font-medium">
                СТРОГОЕ ПРЕДУПРЕЖДЕНИЕ: Расходные материалы для ТО (<strong className="text-red-300">фильтры, свечи зажигания</strong> и т.д.) — главная мишень для подделок. <strong className="text-red-300">Экстремально низкие цены — это всегда рассадник контрафакта.</strong> Мы предоставляем абсолютно прозрачный горизонтальный выбор и навсегда разрушаем информационный вакуум фейков.
              </blockquote>
            </div>
          </div>
        </div>

        {/* Parts Photo Strip — реальные запчасти */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-16">
          {/* Кузовные детали */}
          <div className="relative overflow-hidden rounded-sm" style={{ height: "220px" }}>
            <img
              src="https://readdy.ai/api/search-image?query=automotive%20body%20panels%20set%20for%20European%20premium%20cars%2C%20steel%20car%20hood%20fender%20door%20panel%20wing%20displayed%20on%20clean%20dark%20background%2C%20stamped%20metal%20auto%20body%20parts%20product%20photography%2C%20sharp%20detail%2C%20professional%20studio%20lighting%2C%20no%20text%2C%20isolated%20parts%2C%20high%20quality%20aftermarket%20body%20parts&width=600&height=440&seq=parts_body_kuzov01&orientation=landscape"
              alt="Кузовные детали BMW Mercedes — капоты крылья двери, YAXIN LIANPEI Hangzhou Taizhou cluster"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1A]/85 via-[#0A0F1A]/20 to-transparent"></div>
            <div className="absolute bottom-3 left-3">
              <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.15em] uppercase">Кузовные детали</div>
              <div className="text-white text-xs font-bold">Погрешность штамповки ≤0.5 мм</div>
            </div>
          </div>

          {/* Оптика */}
          <div className="relative overflow-hidden rounded-sm" style={{ height: "220px" }}>
            <img
              src="https://readdy.ai/api/search-image?query=automotive%20LED%20headlight%20assembly%20for%20BMW%20Mercedes%20Audi%2C%20crystal%20clear%20matrix%20LED%20headlamp%20unit%20close%20up%20product%20shot%2C%20modern%20car%20optics%20with%20DRL%20daytime%20running%20lights%2C%20dark%20background%2C%20professional%20product%20photography%2C%20sharp%20detail%2C%20no%20text%2C%20premium%20aftermarket%20auto%20lighting&width=600&height=440&seq=parts_optics_led02&orientation=landscape"
              alt="Оптика LED фары BMW Audi Mercedes — матричный свет, YAXIN LIANPEI Guangzhou Chirun Danyang"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1A]/85 via-[#0A0F1A]/20 to-transparent"></div>
            <div className="absolute bottom-3 left-3">
              <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.15em] uppercase">Оптика и освещение</div>
              <div className="text-white text-xs font-bold">Матричные LED-фары 1:1</div>
            </div>
          </div>

          {/* Подвеска */}
          <div className="relative overflow-hidden rounded-sm" style={{ height: "220px" }}>
            <img
              src="https://readdy.ai/api/search-image?query=automotive%20suspension%20parts%20set%20for%20European%20cars%2C%20forged%20aluminum%20control%20arms%20wishbones%20ball%20joints%20tie%20rod%20ends%20shock%20absorbers%20displayed%20on%20dark%20background%2C%20professional%20product%20photography%2C%20high%20detail%2C%20studio%20lighting%2C%20no%20text%2C%20premium%20aftermarket%20suspension%20components%2C%20metallic%20finish&width=600&height=440&seq=parts_susp_yuhuan02&orientation=landscape"
              alt="Детали подвески кованый алюминий — рычаги шаровые опоры, YAXIN LIANPEI Yuhuan cluster Hangzhou"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1A]/85 via-[#0A0F1A]/20 to-transparent"></div>
            <div className="absolute bottom-3 left-3">
              <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.15em] uppercase">Детали подвески</div>
              <div className="text-white text-xs font-bold">Кованый алюминий · Кластер Юйхуань</div>
            </div>
          </div>

          {/* Система охлаждения */}
          <div className="relative overflow-hidden rounded-sm" style={{ height: "220px" }}>
            <img
              src="https://readdy.ai/api/search-image?query=automotive%20cooling%20system%20components%20for%20European%20premium%20cars%2C%20thick%20aluminum%20radiator%20with%20dense%20fins%20and%20thermostat%20housing%20water%20pump%20coolant%20expansion%20tank%20arranged%20on%20dark%20background%2C%20anti-corrosion%20coating%20visible%20on%20radiator%20surface%2C%20professional%20product%20photography%2C%20sharp%20detail%2C%20no%20text%2C%20aftermarket%20cooling%20parts%20metallic%20silver%20finish&width=600&height=440&seq=parts_cooling_rad03&orientation=landscape"
              alt="Система охлаждения — алюминиевые радиаторы термостаты водяные насосы, YAXIN LIANPEI Hangzhou Guangzhou Chirun экспорт в Россию"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1A]/85 via-[#0A0F1A]/20 to-transparent"></div>
            <div className="absolute bottom-3 left-3">
              <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.15em] uppercase">Система охлаждения</div>
              <div className="text-white text-xs font-bold">Утолщённый алюминий · Антикоррозия</div>
            </div>
          </div>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {micCategories.map((cat) => (
            <div
              key={cat.title}
              className="bg-[#0D1420] border border-[#1E2A3A] p-6 rounded-sm hover:border-[#C9A84C]/40 transition-all duration-300 group"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm group-hover:border-[#C9A84C] transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-[#C9A84C] text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-base mb-0.5" style={{ fontFamily: "'Oswald', sans-serif" }}>{cat.title}</h3>
                  <div className="text-gray-600 text-xs">{cat.cluster}</div>
                </div>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">{cat.desc}</p>
              <div className="flex flex-wrap gap-1.5">
                {cat.specs.map((spec) => (
                  <span key={spec} className="text-gray-400 text-[10px] bg-[#1E2A3A] px-2 py-0.5 rounded-sm whitespace-nowrap">
                    {spec}
                  </span>
                ))}
              </div>
            </div>
          ))}

          {/* Margin highlight card */}
          <div className="bg-gradient-to-br from-[#C9A84C]/15 to-[#0D1420] border border-[#C9A84C]/40 p-6 rounded-sm flex flex-col justify-between">
            <div>
              <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.2em] uppercase mb-3">Ваша выгода</div>
              <div className="text-white font-black mb-2" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "56px", lineHeight: 1 }}>
                2–3×
              </div>
              <div className="text-white font-bold text-lg mb-3">Больше маржи</div>
              <p className="text-gray-400 text-sm leading-relaxed">
                По сравнению с оригинальными запчастями при сопоставимом качестве и надёжности.
              </p>
            </div>
            <a
              href="#contact"
              className="mt-6 flex items-center justify-center gap-2 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-sm px-5 py-3 rounded-sm tracking-wide uppercase transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-3-line"></i>
              Запросить прайс-лист
            </a>
          </div>
        </div>

        {/* Умная рекламация — After-sales system */}
        <div className="mt-12 bg-[#0D1420] border border-[#C9A84C]/30 rounded-sm overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-8 lg:p-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center bg-[#C9A84C]/10 border border-[#C9A84C]/40 rounded-sm">
                  <i className="ri-shield-check-line text-[#C9A84C] text-xl"></i>
                </div>
                <div>
                  <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.25em] uppercase">Послепродажная система</div>
                  <h3 className="text-white font-black text-xl" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: "0.04em" }}>
                    УМНАЯ РЕКЛАМАЦИЯ: «СПИСАНИЕ НА МЕСТЕ»
                  </h3>
                </div>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">
                Если в партии обнаружен брак — не нужно организовывать дорогостоящий возврат в Китай. Просто <strong className="text-white">утилизируйте бракованную деталь на месте</strong> и предоставьте нам фото/видео подтверждение. Мы немедленно выставим кредит-ноту или отправим замену следующей партии.
              </p>
              <div className="flex flex-col gap-3">
                {[
                  { icon: "ri-camera-line", text: "Фото/видео брака → подтверждение за 24 часа" },
                  { icon: "ri-refund-2-line", text: "Кредит-нота или замена в следующей партии" },
                  { icon: "ri-delete-bin-line", text: "Утилизация на месте — никаких возвратов в КНР" },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm flex-shrink-0">
                      <i className={`${item.icon} text-[#C9A84C] text-sm`}></i>
                    </div>
                    <span className="text-gray-300 text-sm">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-gradient-to-br from-[#C9A84C]/8 to-[#080C14] p-8 lg:p-10 flex flex-col justify-center border-t lg:border-t-0 lg:border-l border-[#C9A84C]/20">
              <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase mb-4">Финансовый стандарт</div>
              <div className="grid grid-cols-2 gap-4 mb-6">
                {[
                  { value: "24ч", label: "Подтверждение рекламации" },
                  { value: "0₽", label: "Стоимость возврата в КНР" },
                  { value: "100%", label: "Компенсация брака" },
                  { value: "B2B", label: "Финансовый учёт в рублях" },
                ].map((stat) => (
                  <div key={stat.label} className="text-center p-3 bg-[#0D1420]/60 border border-[#1E2A3A] rounded-sm">
                    <div className="text-[#C9A84C] font-black text-2xl mb-1" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>{stat.value}</div>
                    <div className="text-gray-500 text-[10px] leading-tight">{stat.label}</div>
                  </div>
                ))}
              </div>
              <p className="text-gray-600 text-xs leading-relaxed">
                Система «Списание на месте» соответствует российским стандартам финансового учёта и полностью документируется для вашей бухгалтерии.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
